
import { supabase } from '@/integrations/supabase/client';
import { UserRole } from '@/types/user-roles';

/**
 * Checks if a user has super admin privileges by querying the admins table
 * @param userId The ID of the user to check
 * @returns Promise<boolean> True if the user is a super admin, false otherwise
 */
export async function isSuperAdmin(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('admins')
      .select('role')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }

    return data?.role === 'super_admin';
  } catch (error) {
    console.error('Exception checking admin status:', error);
    return false;
  }
}

/**
 * Gets the admin role for a user from the admins table
 * @param userId The ID of the user to check
 * @returns Promise<UserRole | null> The user's admin role or null if not found
 */
export async function getUserAdminRole(userId: string): Promise<UserRole | null> {
  try {
    const { data, error } = await supabase
      .from('admins')
      .select('role')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error getting admin role:', error);
      return null;
    }

    return data?.role as UserRole || null;
  } catch (error) {
    console.error('Exception getting admin role:', error);
    return null;
  }
}
